// @flow
import getQuestions from 'lib/getQuestions'

const defaultState: QuestionState = {
  items: [],
  currentIndex: 0,
  isLoading: true,
}

export default {
  namespace: 'question',
  state: Object.assign({}, defaultState),
  subscriptions: {
    setup({ dispatch }: { dispatch: Function }): void {
      getQuestions().then(questions => {
        dispatch({ type: 'setItems', payload: questions })
      })
    },
  },
  reducers: {
    setItems(state: QuestionState, { payload }: { payload: Array<Question> }): QuestionState {
      return Object.assign({}, state, {
        items: payload.slice(),
        isLoading: false,
      })
    },
    answer(state: QuestionState, { payload }: { questionId: string, isAnswerCorrect: boolean }): QuestionState {
      const { questionId, isAnswerCorrect } = payload

      const newQuestionItems: Array<Question> = state.items.map(sQuestion => {
        if (sQuestion.id !== questionId) return sQuestion
        return Object.assign({}, sQuestion, { isAnswerCorrect })
      })

      return Object.assign({}, state, {
        items: newQuestionItems,
        currentIndex: state.currentIndex + 1
      })
    },
    reset(): QuestionState {
      return Object.assign({}, defaultState)
    }
  },
  effects: {
    *reset(action, { call, put }) {
      const questions = yield call(getQuestions)
      yield put({ type: 'setItems', payload: questions });
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/question/index.js